import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-customers',
  templateUrl: './delivery-customers.component.html',
  styleUrls: ['./delivery-customers.component.css']
})
export class DeliveryCustomersComponent implements OnInit {
    custNo;

    public setting?: Setting;

    public itemsListCustomers: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadSetting() {
        if (!!this.custNo) {
            this.setting = (await this.datatask.Post(1072, { cust_no: this.custNo }))[0];
        }
    }

    private async loadCustomers() {
        if (!this.setting) return;

        return this.itemsListCustomers = await this.datatask.Post(1073, this.setting);
    }

    private async init() {
        await this.loadSetting();
        this.loadCustomers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    cust_no: string;
}
